
<div class="col">
    <rask-input label="Antal dagar" [(ngModel)]="antalDagar" infoText="Antal dagar signeringens sista datum ska förlängas med. Om förfallo datum passerats kommer tiden förlängas med antal dagar från idag."></rask-input>
    <rask-input
        label="Sista dag för signering"
        [readonly]="true"
        [value]="getEndDate()">
    </rask-input>
</div>
<div class="col pb-5 pt-3">
    <div class="d-inline float-end">
        <rask-button color="primary" (click)="save()">Spara</rask-button>
        <rask-button color="secondary" (click)="abort()">Avbryt</rask-button>
    </div>
</div>